<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png" class="logo">
    <h1>{{ greeting }}</h1>
    <button @click="changeGreeting">Change Greeting</button>
    <HelloWorld :msg="message"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  data() {
    return {
      greeting: 'Welcome to Your Vue.js App!',
      message: 'This is a message from App.vue'
    }
  },
  methods: {
    changeGreeting() {
      this.greeting = 'You clicked the button!';
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.logo {
  height: 150px;
  width: 150px;
  margin-bottom: 20px;
}

button {
  padding: 10px 20px;
  font-size: 16px;
  color: white;
  background-color: #42b983;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #368a6e;
}
</style>
